class HyghDropdown extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const option = event.target.closest('.bis-variant');
    if (!option || !this.contains(option)) return;

    this.querySelectorAll('.bis-variant.selected').forEach((el) => el.classList.remove('selected'));
    option.classList.add('selected');

    const label = this.querySelector('.hygh-dropdown__current-value');
    if (label) label.textContent = option.dataset.value;
  };
}

if (!customElements.get('hygh-dropdown')) {
  customElements.define('hygh-dropdown', HyghDropdown);
}
